import React from 'react';

export function PageHeader({ title, description, actions, eyebrow = 'Student portal' }: { title: string; eyebrow?: string; description?: React.ReactNode; actions?: React.ReactNode }) {
  return <header data-ui="page-header" className="mb-6 flex flex-wrap items-start justify-between gap-3">
    <div className="min-w-0">
      {eyebrow && <p className="momentum-eyebrow">{eyebrow}</p>}
      <h1 className="break-words text-2xl sm:text-3xl font-bold leading-tight tracking-tight text-foreground">{title}</h1>
      {description && <p className="mt-2 max-w-2xl break-words text-sm leading-relaxed text-muted-foreground">{description}</p>}
    </div>
    {actions && <div className="shrink-0">{actions}</div>}
  </header>;
}
